import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Box, media } from '@redriverpress/system'

/**
 * Let us write css rule that will only be activate from rowDirectionStartingAt breakpoint and up.
 * For example: if rowDirectionStartingAt == 'md', writing
 *
 * ${rowDirectionBreakpoint`
 *  ....styles
 * `}
 *
 * is equivalent to write
 *
 * ${media.md`
 *  ....styles
 * `}
 */
const rowDirectionBreakpoint = (...styles) => ({ rowDirectionStartingAt }) => {
  return media[rowDirectionStartingAt](...styles)
}

const StyledFieldGroup = styled(Box)`
  ${rowDirectionBreakpoint`
    display: flex;
    align-items: flex-start;

    > * {
      flex: 1 1 0;
      padding-left: ${({ theme }) => theme.space[2]};
      padding-right: ${({ theme }) => theme.space[2]};

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  `}
`

/**
 * This component is a container for a group of fields.
 * Each field on the group starts on an individual row (mobile size).
 * Then when the breakpoint (props.rowDirectionStartingAt) is reached they are shown all in one row.
 *
 * Also this component deals with padding within fields.
 */
export default function FieldGroup({ children, ...props }) {
  return <StyledFieldGroup {...props}>{children}</StyledFieldGroup>
}

FieldGroup.propTypes = {
  children: PropTypes.node.isRequired,
  rowDirectionStartingAt: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
}

FieldGroup.defaultProps = {
  rowDirectionStartingAt: 'md',
}
